import React from 'react';

const Copy = () => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      {/* eslint-disable-next-line max-len */}
      <path d='M4 1H8.73333C10.2268 1 10.9735 1 11.544 1.29065C12.0457 1.54631 12.4537 1.95426 12.7094 2.45603C13 3.02646 13 3.77319 13 5.26667V10M3.13333 13H8.53333C9.28007 13 9.65344 13 9.93865 12.8547C10.1895 12.7268 10.3935 12.5229 10.5213 12.272C10.6667 11.9868 10.6667 11.6134 10.6667 10.8667V5.46667C10.6667 4.71993 10.6667 4.34656 10.5213 4.06135C10.3935 3.81046 10.1895 3.60649 9.93865 3.47866C9.65344 3.33333 9.28007 3.33333 8.53333 3.33333H3.13333C2.3866 3.33333 2.01323 3.33333 1.72801 3.47866C1.47713 3.60649 1.27316 3.81046 1.14532 4.06135C1 4.34656 1 4.71993 1 5.46667V10.8667C1 11.6134 1 11.9868 1.14532 12.272C1.27316 12.5229 1.47713 12.7268 1.72801 12.8547C2.01323 13 2.3866 13 3.13333 13Z' stroke='#4F7D8A' stroke-linecap='round' stroke-linejoin='round'/>
    </svg>
  );
};

export default Copy;